export default {
  url: 'https://pxeayz6ytzdeja6vphgkheksmy.appsync-api.us-east-1.amazonaws.com/graphql',
  apiKey: 'da2-ekn7l7bcxbed7pfnj4bykfcn7e'
}
